export default __webpack_public_path__ + "8285b236b998f3e7b84d1a2ca51a4dc1.png";